import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { BillingCycleTypes } from '../../models/domain/invoice';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { NewSubscriptionDataResponse } from '../../models/ss-api/responses/new.subscription.data.response';
import { SelectItem } from 'primeng/primeng';
import { AddLicenseRequest } from '../../models/ss-api/requests/add.license.request';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

export interface IAddLicenseDialogModel {
    title: string;
    subTitle: string;
    message: string;
    MemberID: number;
    requireSetupFee: boolean;
    AvailableCredit: number;
}

interface ProductOption {
    ID: number;
    Name: string;
}

interface CycleOption {
    CycleType: BillingCycleTypes;
    Name: string;
}

@Component({
    selector: 'add-license-dialog',
    styleUrls: ['./add.license.dialog.css'],
    templateUrl: './add.license.dialog.html'
})
export class AddLicenseDialog extends DialogComponent<IAddLicenseDialogModel, boolean> implements IAddLicenseDialogModel, OnInit {

    IsBusy: boolean = false;

    title: string;
    subTitle: string;
    message: string;
    MemberID: number;
    requireSetupFee: boolean = true;
    
    State: string = "";
    TaxRateDisplay: string = "";
    TotalTax: number = 0;

    subscriptionData: NewSubscriptionDataResponse;

    products: SelectItem[] = [];
    selectedProduct: ProductOption;


    billingCycles: SelectItem[] = [];
    selectedCycle: CycleOption;


    selectedProductPrice: number = 0;
    selectedSignupFee: number = 0;
    total: number = 0;

    ShowYardAddon = false;
    addYARD: boolean = false;
    YARDPrice: number = 0;

    creditCards: SelectItem[] = [];
    selectedCreditCard: number = 0;

    assignToMember: boolean = true;
    designerName: string = '';
    designerEmail: string = '';

    AvailableCredit: number = 0;
    Credit: number = 0;


    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public gb: GlobalService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.getSubscriptionData();
        console.log(this.AvailableCredit);
    }

    async getSubscriptionData() {

        this.IsBusy = true;

        await this.api.LicenseGetNewSubscriptionData(this.MemberID).subscribe(
            result => {
                console.log("result", result);
                this.IsBusy = false;
                this.subscriptionData = result.Data;
                this.State = result.Data.State;
                this.setUpDropdowns();
            },
            error => {
                this.IsBusy = false;
            }
        );

    }

    setUpDropdowns() {

        this.subscriptionData.AvailableProducts.forEach(e => {
            let newProduct: SelectItem = { label: e.Name, value: { ID: e.ID, Name: e.Name } };
            this.products.push(newProduct);
        });
        this.selectedProduct = this.products[0].value;


        console.log("availableprods", this.products);

        this.billingCycles = [
            { label: 'Monthly', value: { CycleType: BillingCycleTypes.Monthly, Name: 'Monthly' } },
            { label: 'Yearly', value: { CycleType: BillingCycleTypes.Annually, Name: 'Yearly' } }
        ]
        this.selectedCycle = this.billingCycles[0].value;

        // Sort the cards so the default is always the first option
        let sortedCreditCards = this.subscriptionData.CreditCards.sort(function (a, b) {
            return (a.IsDefault === b.IsDefault) ? 0 : a.IsDefault ? -1 : 1;
        })

        sortedCreditCards.forEach(e => {

            if (!e.IsActive || e.IsDeleted || (!e.IsDefault && e.Status == 'Expired'))
                return;

            let newCard: SelectItem = {
                label: e.FirstName + ' ' + e.LastName + ' - XXXX XXXX XXXX ' + e.LastFour, value: e.ID
            };
            this.creditCards.push(newCard);
        });

        if (this.creditCards.length > 0)
            this.selectedCreditCard = this.creditCards[0].value;
        else
            this.ShowNoCreditCardError();

        this.ProductChanged();
    }

    ShowNoCreditCardError() {
        this.sweetAlertService.swal(
            {
                title: 'Error',
                text: 'No Credit Cards On this Account.',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'OK',
            })
            .then((response: any) => {
                this.result = true;
                this.IsBusy = false;
                this.close();
            }, (dismiss) => {
                this.result = false;
                this.IsBusy = false;
                this.close();
                return;
            }); // keep this line to prevent promise error;
    }

    // CHANGED EVENTS
    ProductChanged() {
        console.log("productchanged");
        let newPrice = 0;
        let newSignupFee = 0;
        let taxAmount = 0;
        let yardTax = 0;

        if (this.addYARD == false)
        {
            this.YARDPrice = 0;
            yardTax = 0;
        }

        this.subscriptionData.AvailableProducts.forEach(x => {
            if (x.ID == this.selectedProduct.ID) {

                // show yard if available
                this.ShowYardAddon = x.YardAddon != null && x.YardAddon != undefined;

                console.log("x", x);
                this.TaxRateDisplay = x.TaxRateDisplay;
                if (this.selectedCycle.CycleType == BillingCycleTypes.Monthly) {
                    newPrice += x.PriceMonthly;
                    newSignupFee += x.SetupMonthly;
                    if (this.requireSetupFee){
                        taxAmount += x.TotalTaxMonthly;
                    }
                    else{
                        taxAmount += x.TotalTaxMonthlyNoSetup;
                    }
                    if (this.addYARD && x.YardAddon != null) {
                        this.YARDPrice = x.YardAddon.PriceMonthly;
                        newSignupFee += x.YardAddon.SetupMonthly
                        if (this.requireSetupFee){
                            yardTax += x.YardAddon.TotalTaxMonthly;
                        }
                        else{
                            yardTax += x.YardAddon.TotalTaxMonthlyNoSetup;
                        }   
                    }
                } else {
                    newPrice += x.PriceYearly;
                    newSignupFee += x.SetupYearly;
                    if (this.requireSetupFee){
                        taxAmount += x.TotalTaxYearly;
                    }
                    else{
                        taxAmount += x.TotalTaxYearlyNoSetup;
                    }
                    if (this.addYARD && x.YardAddon != null) {
                        this.YARDPrice = x.YardAddon.PriceYearly;
                        newSignupFee += x.YardAddon.SetupYearly
                        if (this.requireSetupFee){
                            yardTax += x.YardAddon.TotalTaxYearly;
                        }
                        else{
                            yardTax += x.YardAddon.TotalTaxYearlyNoSetup;
                        }   
                        
                    }
                }
                if (x.YardAddon == null) {
                    this.YARDPrice = 0;
                    this.addYARD = false;
                    yardTax = 0;
                }
            }
        });

        taxAmount = taxAmount  * 100;
        taxAmount = Math.round(taxAmount);
        taxAmount = taxAmount / 100;

        yardTax = yardTax  * 100;
        yardTax = Math.round(yardTax);
        yardTax = yardTax / 100;

        this.TotalTax = taxAmount + yardTax;

        this.selectedProductPrice = newPrice;
        this.selectedSignupFee = newSignupFee;

        if (this.requireSetupFee){
            this.total = newPrice + newSignupFee + this.YARDPrice + this.TotalTax;
        }
        else{
            this.total = newPrice + this.YARDPrice + this.TotalTax;
        }

        if (this.AvailableCredit > 0) {
            let subtotal = this.total - this.AvailableCredit;
            if (subtotal < 0) {
                this.Credit = this.total;
                this.total = 0;
            } else {
                this.total = subtotal;
                this.Credit = this.AvailableCredit;
            }
        }

    }

    BillingCycleChanged(e) {

    }

    CreditCardChanged(e) {
        this.selectedCreditCard = e.value;
    }

    async confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code

        let request = new AddLicenseRequest();
        request.MemberID = this.MemberID;
        request.ProductID = this.selectedProduct.ID;
        request.AssignToOwner = this.assignToMember;
        request.BillingCycle = this.selectedCycle.CycleType;
        request.CreditCardID = this.selectedCreditCard;
        request.YardAddon = this.addYARD;
        request.DesignerEmail = this.designerEmail;
        request.DesignerName = this.designerName;

        console.log("Add License Request: ", request);

        await this.sweetAlertService.swal(
            {
                title: 'Add New License?',
                text: 'Are you sure you want to add a new license?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, add License!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.LicenseAdd(request).toPromise();
                }
            })
            .then(response => {
                this.result = true;
                this.close();

                if (!response.Result) {
                    // error
                    this.sweetAlertService.swal(
                        {
                            title: 'Process/Payment Error',
                            text: response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then((response: any) => {
                            this.result = false;
                            this.IsBusy = false;
                            this.close();
                        }, (dismiss) => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                    return;
                }

                this.sweetAlertService.swal(
                    {
                        title: 'Success!',
                        text: 'License Added',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                        this.IsBusy = false;

                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = true;
                        this.IsBusy = false;
                        this.close();
                    }, (dismiss) => {
                        this.result = false;
                        this.IsBusy = false;
                        this.close();
                        return;
                    }); // keep this line to prevent promise error;
            });

    }

}
